import * as z from "zod"

export const lifePlanSchema = z.object({
  basicInfo: z.object({
    name: z.string().optional(),
    age: z.number().min(0).max(120),
    gender: z.string(),
    familyStructure: z.object({
      hasSpouse: z.boolean(),
      spouseAge: z.number().min(0).max(120).optional(),
      children: z.array(
        z.object({
          age: z.number().min(-10).max(50),
        }),
      ),
    }),
  }),
  income: z.object({
    annualIncome: z.number().min(0),
    salaryIncreaseRate: z.number().min(0),
    annualBonus: z.number().min(0),
  }),
  expense: z.object({
    housingCost: z.number().min(0),
    utilities: z.number().min(0),
    food: z.number().min(0),
    communication: z.number().min(0),
    transportation: z.number().min(0),
    entertainment: z.number().min(0),
    other: z.number().min(0),
  }),
  investment: z.object({
    stocks: z.number().min(0),
    bonds: z.number().min(0),
    mutualFunds: z.number().min(0),
    insurance: z.number().min(0),
    other: z.number().min(0),
  }),
  assets: z.object({
    savings: z.object({
      amount: z.number().min(0),
      return: z.number().min(0),
      volatility: z.number().min(0),
    }),
    stocks:z.object({
      amount: z.number().min(0),
      return: z.number().min(0),
      volatility: z.number().min(0),
    }),
    bonds: z.object({
      amount: z.number().min(0),
      return: z.number().min(0),
      volatility: z.number().min(0),
    }),
    mutualFunds: z.object({
      amount: z.number().min(0),
      return: z.number().min(0),
      volatility: z.number().min(0),
    }),
    insurance: z.object({
      amount: z.number().min(0),
      return: z.number().min(0),
      volatility: z.number().min(0),
    }),
    other: z.object({
      amount: z.number().min(0),
      return: z.number().min(0),
      volatility: z.number().min(0),
    }),
  }),
  liabilities: z.object({
    housingLoan: z.array(
      z.object({
        name: z.string(),
        amount: z.number().min(0),
        period: z.number().min(0),
        interestRate: z.number().min(0),
      }),
    ),
    otherLoans: z.array(
      z.object({
        name: z.string(),
        amount: z.number().min(0),
        period: z.number().min(0),
        interestRate: z.number().min(0),
      }),
    ),
  }),
  lifeGoals: z.object({
    housingPurchase: z.object({
      planned: z.boolean(),
      year: z.number().min(0),
      amount: z.number().min(0),
    }),
    educationFunds: z.array(
      z.object({
        name: z.string(),
        age: z.number().min(0),
        amount: z.number().min(0),
      }),
    ),
    otherGoals: z.array(
      z.object({
        name: z.string(),
        year: z.number().min(0),
        amount: z.number().min(0),
      }),
    ),
    retirementAge: z.number().min(50).max(100),
    retirementMonthlyExpense: z.number().min(0),
  }),
  simulationSettings: z.object({
    inflationRate: z.number().min(0),
    investmentReturn: z.number().min(0),
    simulationPeriod: z.number().min(1).max(100),
  }),
})
